// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prepR_kos_page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Header ── */
.prepR_kos_header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding-top: 6px;
}

.prepR_kos_title {
  font-size: 22px;
  font-weight: 700;
  color: #0b0b0b;
  margin: 0 0 4px 0;
}

.prepR_kos_subtitle {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
  max-width: 500px;
}

.prepR_kos_header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding-top: 6px;
}

/* ── Tabs ── */
.prepR_kos_tabs {
  display: flex;
  gap: 4px;
  background: #f0f0f0;
  border-radius: 8px;
  padding: 4px;
  width: fit-content;
}

.prepR_kos_tab {
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background: transparent;
  color: #6b6b6b;
  transition: background 0.15s, color 0.15s;
}

.prepR_kos_tab-active {
  background: #ffffff;
  color: #0b0b0b;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* ── Groups ── */
.prepR_kos_groups {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.prepR_kos_group {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  overflow: hidden;
}

.prepR_kos_group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.prepR_kos_group-title {
  font-size: 15px;
  font-weight: 600;
  color: #0b0b0b;
  margin: 0 0 2px 0;
}

.prepR_kos_group-sub {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
}

/* ── Cell helpers ── */
.prepR_kos_time {
  color: #6b6b6b;
}

.prepR_kos_unit {
  color: #949494;
  font-size: 13px;
}

.prepR_kos_slot-label {
  color: #0860e6;
  font-weight: 500;
}

/* ── Priority Badge ── */
.prepR_kos_badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
}

.prepR_kos_badge-high {
  background: #ffe9e9;
  color: #e90000;
}

.prepR_kos_badge-medium {
  background: #fff4e5;
  color: #eba85a;
}

.prepR_kos_badge-low {
  background: #f0f0f0;
  color: #6b6b6b;
}

/* ── Review button ── */
.prepR_kos_review-btn {
  background: none;
  border: none;
  color: #0860e6;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
}

.prepR_kos_review-btn:hover {
  text-decoration: underline;
}

/* ─── New Request Modal ────────────────────────────────────────────────────── */

.prepR_kos_nrm-subtitle {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0 0 18px;
}

.prepR_kos_nrm-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 20px;
}

.prepR_kos_nrm-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.prepR_kos_nrm-label {
  font-size: 12px;
  font-weight: 500;
  color: #4b4b4b;
}

.prepR_kos_nrm-input {
  height: 38px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 13px;
  color: #0b0b0b;
  background: #fff;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  font-family: inherit;
}

.prepR_kos_nrm-input:focus {
  border-color: #0860e6;
}

.prepR_kos_nrm-items-section {
  border-top: 1px solid #f0f0f0;
  padding-top: 16px;
}

.prepR_kos_nrm-items-title {
  font-size: 14px;
  font-weight: 600;
  color: #0b0b0b;
  margin: 0 0 12px;
}

.prepR_kos_nrm-item-row {
  display: grid;
  grid-template-columns: 1fr 100px 120px 32px;
  gap: 10px;
  align-items: end;
  background: #f9f9f9;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 8px;
}

.prepR_kos_nrm-delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: #b0b0b0;
  padding: 4px;
  border-radius: 6px;
  transition: color 0.15s, background 0.15s;
  margin-bottom: 2px;
}

.prepR_kos_nrm-delete-btn:hover {
  color: #e90000;
  background: #fef2f2;
}

.prepR_kos_nrm-add-item-btn {
  width: 100%;
  height: 40px;
  border: 1.5px dashed #c8c8c8;
  border-radius: 8px;
  background: none;
  cursor: pointer;
  font-size: 13px;
  color: #6b6b6b;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 4px;
  transition: border-color 0.15s, color 0.15s;
  font-family: inherit;
}

.prepR_kos_nrm-add-item-btn:hover {
  border-color: #0860e6;
  color: #0860e6;
}

/* ── Filter badge on Filter button ── */
.prepR_kos_filter-btn-wrapper {
  position: relative;
  display: inline-flex;
}

.prepR_kos_filter-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  background: #1976d2;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  pointer-events: none;
}

/* ── Empty filter result ── */
.prepR_kos_no-results {
  font-size: 13px;
  color: #6b6b6b;
  padding: 32px 20px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/Kitchen-OS/components/prepRequest-kitchenOS.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iFAAiF;;AAEjF;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".prepR_kos_page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ── Header ── */\n.prepR_kos_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  padding-top: 6px;\n}\n\n.prepR_kos_title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #0b0b0b;\n  margin: 0 0 4px 0;\n}\n\n.prepR_kos_subtitle {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n  max-width: 500px;\n}\n\n.prepR_kos_header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  padding-top: 6px;\n}\n\n/* ── Tabs ── */\n.prepR_kos_tabs {\n  display: flex;\n  gap: 4px;\n  background: #f0f0f0;\n  border-radius: 8px;\n  padding: 4px;\n  width: fit-content;\n}\n\n.prepR_kos_tab {\n  padding: 7px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  background: transparent;\n  color: #6b6b6b;\n  transition: background 0.15s, color 0.15s;\n}\n\n.prepR_kos_tab-active {\n  background: #ffffff;\n  color: #0b0b0b;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* ── Groups ── */\n.prepR_kos_groups {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.prepR_kos_group {\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.prepR_kos_group-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.prepR_kos_group-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0b0b0b;\n  margin: 0 0 2px 0;\n}\n\n.prepR_kos_group-sub {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n/* ── Cell helpers ── */\n.prepR_kos_time {\n  color: #6b6b6b;\n}\n\n.prepR_kos_unit {\n  color: #949494;\n  font-size: 13px;\n}\n\n.prepR_kos_slot-label {\n  color: #0860e6;\n  font-weight: 500;\n}\n\n/* ── Priority Badge ── */\n.prepR_kos_badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.prepR_kos_badge-high {\n  background: #ffe9e9;\n  color: #e90000;\n}\n\n.prepR_kos_badge-medium {\n  background: #fff4e5;\n  color: #eba85a;\n}\n\n.prepR_kos_badge-low {\n  background: #f0f0f0;\n  color: #6b6b6b;\n}\n\n/* ── Review button ── */\n.prepR_kos_review-btn {\n  background: none;\n  border: none;\n  color: #0860e6;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 0;\n}\n\n.prepR_kos_review-btn:hover {\n  text-decoration: underline;\n}\n\n/* ─── New Request Modal ────────────────────────────────────────────────────── */\n\n.prepR_kos_nrm-subtitle {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0 0 18px;\n}\n\n.prepR_kos_nrm-grid-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  margin-bottom: 20px;\n}\n\n.prepR_kos_nrm-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.prepR_kos_nrm-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #4b4b4b;\n}\n\n.prepR_kos_nrm-input {\n  height: 38px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 0 12px;\n  font-size: 13px;\n  color: #0b0b0b;\n  background: #fff;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.prepR_kos_nrm-input:focus {\n  border-color: #0860e6;\n}\n\n.prepR_kos_nrm-items-section {\n  border-top: 1px solid #f0f0f0;\n  padding-top: 16px;\n}\n\n.prepR_kos_nrm-items-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0b0b0b;\n  margin: 0 0 12px;\n}\n\n.prepR_kos_nrm-item-row {\n  display: grid;\n  grid-template-columns: 1fr 100px 120px 32px;\n  gap: 10px;\n  align-items: end;\n  background: #f9f9f9;\n  border: 1px solid #ebebeb;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 8px;\n}\n\n.prepR_kos_nrm-delete-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #b0b0b0;\n  padding: 4px;\n  border-radius: 6px;\n  transition: color 0.15s, background 0.15s;\n  margin-bottom: 2px;\n}\n\n.prepR_kos_nrm-delete-btn:hover {\n  color: #e90000;\n  background: #fef2f2;\n}\n\n.prepR_kos_nrm-add-item-btn {\n  width: 100%;\n  height: 40px;\n  border: 1.5px dashed #c8c8c8;\n  border-radius: 8px;\n  background: none;\n  cursor: pointer;\n  font-size: 13px;\n  color: #6b6b6b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-top: 4px;\n  transition: border-color 0.15s, color 0.15s;\n  font-family: inherit;\n}\n\n.prepR_kos_nrm-add-item-btn:hover {\n  border-color: #0860e6;\n  color: #0860e6;\n}\n\n/* ── Filter badge on Filter button ── */\n.prepR_kos_filter-btn-wrapper {\n  position: relative;\n  display: inline-flex;\n}\n\n.prepR_kos_filter-badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  min-width: 18px;\n  height: 18px;\n  background: #1976d2;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  border-radius: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n  pointer-events: none;\n}\n\n/* ── Empty filter result ── */\n.prepR_kos_no-results {\n  font-size: 13px;\n  color: #6b6b6b;\n  padding: 32px 20px;\n  text-align: center;\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
